export default "__VITE_ASSET__Hx9mxpkt__"